import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';

export default function InboxPanelHeaderSkeleton(): JSX.Element {
  return (
    <Box
      css={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 'layout.looser',
        paddingInline: 'tight',
      }}
    >
      <Bone type="line" css={{ paddingTop: 'loose', marginBottom: 'default', width: '50%' }} />
      <Bone type="line" css={{ marginBottom: 'default', width: '66.67%' }} />
      <Bone type="line" css={{ marginBottom: 'default', width: '50%' }} />
    </Box>
  );
}
